/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TenantNames } from './tenantNames';
import type { TenantContactDb } from './tenantContactDb';
import type { TenantPublicTheme } from './tenantPublicTheme';
import type { TenantImageAssetUrls } from './tenantImageAssetUrls';
import type { SystemMessage } from './systemMessage';
import type { MaintenanceState } from './maintenanceState';
import type { TenantPublicGradingSettings } from './tenantPublicGradingSettings';
import type { TenantPublicProcessSettings } from './tenantPublicProcessSettings';
import type { TenantPublicSettingsEventKinds } from './tenantPublicSettingsEventKinds';

/**
 * Public settings for tenants that should be available before login
 */
export interface TenantPublicSettings {
  naming: TenantNames;
  contact: TenantContactDb;
  theme: TenantPublicTheme;
  imageAssetUrls: TenantImageAssetUrls;
  systemMessages?: SystemMessage[];
  maintenanceState: MaintenanceState;
  gradingSettings: TenantPublicGradingSettings;
  processSettings: TenantPublicProcessSettings;
  eventKinds?: TenantPublicSettingsEventKinds;
}
